/* React */
import React from 'react';

/* Styled Components */
import { SuccessContainer, DeleteImg, Header } from './styles';

interface DeleteClassroomSuccessProps {
  header?: any;
}

const DeleteClassroomSuccess: React.FC<DeleteClassroomSuccessProps> = ({
  header = 'Deleted Classroom',
}) => {
  return (
    <SuccessContainer>
      <DeleteImg />
      <Header>{header}</Header>
    </SuccessContainer>
  );
};

export default DeleteClassroomSuccess;
